//import * as moment from 'moment/moment'; //this works for non-rollup (i.e. dev)
//import moment from 'moment-es6'; //this works for rollup

import * as momentLib from "moment/moment"; 
const moment = (momentLib as any).default ? (momentLib as any).default : momentLib;

export class DateUtil  {
    
    constructor() 
    { 
        
    }

    public static GetCurrentDate() : string {
        return moment().format('MM-DD-YYYY');
    }
  
    public static ConvertDateToJS(date: Date): Date{
        if (date){
            return moment(date).toDate();
        }
    }

    public static ConvertJSDateToDateString(date: Date): string {
        
        if (date){
            var day = date.getDate().toString();       // yields date
            if (day.length == 1){
                day = "0" + day;
            }
            var month = (date.getMonth() + 1).toString();    // yields month (add one as '.getMonth()' is zero indexed)
            if (month.length == 1){
                month = "0" + month;
            }
            var year = date.getFullYear();  // yields year
            var hour = date.getHours().toString();     // yields hours 
            if (hour.length == 1){
                hour = "0" + hour;
            }
            var minute = date.getMinutes().toString(); // yields minutes
            if (minute.length == 1){
                minute = "0" + minute;
            }
            var second = date.getSeconds().toString(); // yields seconds
            if (second.length == 1){
                second = "0" + second;
            }
    
            var dateTime = month + "/" + day + "/" + year + " " + hour + ':' + minute + ':' + second; 
    
            return dateTime;
        }
        else{
            return "";
        }

        
    }
}